import { render, staticRenderFns } from "./TenderComponent.vue?vue&type=template&id=50e2127c&lang=true&"
import script from "./TenderComponent.vue?vue&type=script&lang=js&"
export * from "./TenderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports